import axios from 'axios';
import customAxios from '@/utils/custom-axios';

export class AppointmentsServiceClass {
  baseApiUrl = `${process.env.VUE_APP_API}/appointments`;

  /**
   *
   * @param {string} patientToken
   */
  generatePatientHeaders(patientToken) {
    return {
      Authorization: `Token ${patientToken}`,
    };
  }

  /**
   *
   * @param {string} patientToken
   */
  getAppointments(patientToken) {
    return axios.get(
      this.baseApiUrl,
      {
        headers: this.generatePatientHeaders(patientToken),
      },
    );
  }

  /**
   *
   * @param {string} patientToken
   */
  getAppointmentsDenied(patientToken) {
    return axios.get(
      `${this.baseApiUrl}/denied`,
      {
        headers: this.generatePatientHeaders(patientToken),
      },
    );
  }

  /**
   *
   * @param {string} patientToken
   */
  getAppointmentsPending(patientToken) {
    return axios.get(
      `${this.baseApiUrl}/requests`,
      {
        headers: this.generatePatientHeaders(patientToken),
      },
    );
  }

  getAppointmentRequests() {
    return customAxios.get(`${this.baseApiUrl}/newrequests`);
  }

  getAllActiveAppointments(patientToken) {
    return Promise.all([
      this.getAppointments(patientToken),
      this.getAppointmentsPending(patientToken),
      this.getAppointmentsDenied(patientToken),
    ]);
  }
}

export const AppointmentsService = new AppointmentsServiceClass();
